import React, { useEffect, useState } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const DonutProMain = (props) => {
  // let labelText = ''
  // if (props.data.text) {
  //     labelText = "</br><span className='full'>" + props.data.text + "</span>";
  // }
  const [options, setOptions] = useState({});

  useEffect(() => {
    let labelText = "";

    if (props.data.text) {
      labelText = "</br><span className='full' style={{color:'white}}>" + props.data.text + "</span>";
    }
    if (Object.keys(props.data).length > 0) {
      setOptions({
        chart: {
          type: "solidgauge",
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
          backgroundColor:'transparent'
        },
        title: {
          text: "",
        },
        tooltip: {
          enabled: false,
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          clip: false,
          background: [
            {
              outerRadius: "100%",
              innerRadius: "75%",
              borderWidth: 0,
              backgroundColor: "#93AEC7",
            },
          ],
        },

        yAxis: {
          min: 0,
          max: props?.total,
          lineWidth: 0,
          tickPositions: [],
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false,
              format: props.data.isDisplayVal
                ? props.data.value + props.data.type + labelText
                : labelText,
              verticalAlign: "middle",
              borderWidth: 0,
              useHTML: true,
              // style:{
              //   fontSize:'20px'
              // }
            },
          },
        },
        series: [
          {
            data: [
              {
                name: props.name,
                // color: "#93AEC7",
                color: props.data.bgcolor,

                radius: "100%",
                innerRadius: "75%",
                y: parseInt(props.data.value), //parseInt($(this).data('value')),
              },
            ],
          },
        ],
      });
    }
  }, [props]);

  return (
    <HighchartsReact
      options={options}
      highcharts={Highcharts}
      containerProps={{ className: "custom-circle-progress label-center" }}
    />
  );
};

export default DonutProMain;
